import { keyMirror } from '@tunein/web-utils';

export default keyMirror('BrickTile', 'Tile', 'LandscapeImage', 'Cell');
